/* ============================================================
   LOW KEY AUTOMOTIVE — MY GARAGE + SMART FITMENT ENGINE (diesel + gas)
   Persistent multi-vehicle garage, fits-my-truck badges,
   header garage widget, vehicle-aware search context
   ============================================================ */

window.LKGarage = (function() {

  var STORAGE_KEY = 'lk_garage_v2';
  var ACTIVE_KEY  = 'lk_active_vehicle';
  var NO_ACTIVE   = '__none__';

  // ── STORAGE ────────────────────────────────────────────────
  function load() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); } catch(e) { return []; }
  }
  function save(garage) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(garage)); } catch(e) {}
  }
  function getActive() {
    try {
      var id = localStorage.getItem(ACTIVE_KEY);
      if (id === NO_ACTIVE) return null;
      var g  = load();
      if (id) { var v = g.filter(function(v){ return v.id === id; })[0]; if (v) return v; }
      return g[0] || null;
    } catch(e) { return null; }
  }

  function clean(v) {
    return String(v || '').trim();
  }

  function norm(v) {
    return clean(v).toLowerCase();
  }

  function vehicleLabel(v) {
    if (!v) return '';
    return clean(v.year) + ' ' + clean(v.make) + ' ' + clean(v.model) + (v.engine ? ' - ' + clean(v.engine) : '');
  }

  function isGasEngine(engine) {
    return /\bgas\b/i.test(engine || '');
  }

  function isDieselEngine(engine) {
    if (isGasEngine(engine)) return false;
    return /(diesel|duramax|power\s*stroke|powerstroke|cummins|ecodiesel|6\.6l|6\.7l|5\.9l|7\.3l|6\.0l|6\.4l|3\.0l power stroke|lml|l5p|lb7|lly|lbz|lmm)/i.test(engine || '');
  }

  // Only auto-pick when there is exactly one choice. A 2020+ Silverado 1500 can be
  // 3.0L Duramax OR gas, so the customer has to choose.
  function maybeAutoSelectDieselEngine(sel, engines) {
    if (engines && engines.length === 1) sel.value = engines[0];
  }

  var GAS_COLLECTIONS = {
    chevrolet: 'gas-chevy-gmc-truck-parts',
    gmc: 'gas-chevy-gmc-truck-parts',
    ford: 'gas-ford-truck-parts',
    dodge: 'gas-ram-dodge-truck-parts',
    ram: 'gas-ram-dodge-truck-parts',
    jeep: 'jeep-parts'
  };

  function isGasVehicle(vehicle) {
    if (!vehicle) return false;
    if (isGasEngine(vehicle.engine)) return true;
    return norm(vehicle.make) === 'jeep' && !isDieselEngine(vehicle.engine);
  }

  function targetCollectionForVehicle(vehicle) {
    if (!vehicle) return 'all';
    var make = norm(vehicle.make);
    var model = norm(vehicle.model);
    var engine = clean(vehicle.engine);
    var hasEngine = !!engine;
    var diesel = isDieselEngine(engine);

    if (isGasVehicle(vehicle)) return GAS_COLLECTIONS[make] || 'all';
    if (hasEngine && !diesel) return 'all';
    if (make === 'chevrolet' || make === 'gmc') {
      return diesel || /(2500|3500|hd|colorado|canyon)/.test(model) ? 'duramax' : 'all';
    }
    if (make === 'ford') {
      return diesel || /(f-250|f-350|f-450|f-550|super duty|excursion)/.test(model) ? 'powerstroke-1' : 'all';
    }
    if (make === 'dodge' || make === 'ram') {
      if (/1500/.test(model) && !diesel) return 'all';
      return diesel || /(2500|3500|4500|5500)/.test(model) ? 'cummins' : 'all';
    }
    return 'all';
  }

  function vehicleSearchParams(vehicle) {
    var params = new URLSearchParams();
    if (!vehicle) return params;
    params.set('year', clean(vehicle.year));
    params.set('make', clean(vehicle.make));
    params.set('model', clean(vehicle.model));
    if (clean(vehicle.engine)) params.set('engine', clean(vehicle.engine));
    return params;
  }

  function targetUrlForVehicle(vehicle) {
    return '/collections/' + targetCollectionForVehicle(vehicle) + '?' + vehicleSearchParams(vehicle).toString();
  }

  function currentCollectionHandle() {
    if (window.LK_COLLECTION_HANDLE) return String(window.LK_COLLECTION_HANDLE);
    var m = window.location.pathname.match(/\/collections\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  function collectionMatchesVehicle(vehicle) {
    var target = targetCollectionForVehicle(vehicle);
    if (target === 'all') return true;
    var handle = currentCollectionHandle().toLowerCase();
    var families = {
      duramax: ['duramax','lb7','lly','lbz','lmm','lml','l5p'],
      cummins: ['cummins','12v','24v','common-rail','6-7l-cummins'],
      'powerstroke-1': ['powerstroke','powerstroke-1','power-stroke','7-3l','6-0l','6-4l','6-7l-power']
    };
    if (isGasVehicle(vehicle)) return handle === target || handle === 'gas-truck-parts' || handle === 'all';
    return (families[target] || []).some(function(h) { return handle.indexOf(h) !== -1; });
  }

  function isCollectionPage() {
    return !!document.getElementById('product-grid') || /^\/collections\//.test(window.location.pathname);
  }

  function emitGarageEvent(name, detail) {
    try { document.dispatchEvent(new CustomEvent(name, { detail: detail || {} })); } catch(e) {}
    try { window.dispatchEvent(new CustomEvent(name, { detail: detail || {} })); } catch(e) {}
  }

  function broadcastGarageChanged(vehicle) {
    emitGarageEvent('lk:garageChanged', { active: vehicle || null });
  }

  function syncActiveLabels(vehicle) {
    var label = vehicleLabel(vehicle);
    document.querySelectorAll('[data-active-vehicle-label]').forEach(function(el) {
      el.textContent = label;
    });
    document.querySelectorAll('[data-garage-active-state]').forEach(function(el) {
      el.style.display = vehicle ? '' : 'none';
    });
    document.querySelectorAll('[data-garage-empty-state]').forEach(function(el) {
      el.style.display = vehicle ? 'none' : '';
    });
    document.querySelectorAll('[data-active-vehicle-url]').forEach(function(el) {
      if (vehicle) {
        el.href = targetUrlForVehicle(vehicle);
        el.removeAttribute('aria-disabled');
        el.classList.remove('is-disabled');
      } else {
        el.href = '/collections/all';
        el.setAttribute('aria-disabled', 'true');
        el.classList.add('is-disabled');
      }
    });
    ['collection-active-vehicle'].forEach(function(id) {
      var el = document.getElementById(id);
      if (el) el.style.display = vehicle ? 'flex' : 'none';
    });
  }

  function syncVehicleToUrl(vehicle) {
    try {
      var url = new URL(window.location.href);
      ['year','make','model','engine'].forEach(function(key) { url.searchParams.delete(key); });
      vehicleSearchParams(vehicle).forEach(function(value, key) { url.searchParams.set(key, value); });
      window.history.replaceState({}, '', url.toString());
    } catch(e) {}
  }

  function syncVehicleToCollectionControls(vehicle) {
    if (!vehicle) return;
    var yearSel   = document.getElementById('filter-year');
    var makeSel   = document.getElementById('filter-make');
    var modelSel  = document.getElementById('filter-model');
    var engineSel = document.getElementById('filter-engine');
    var searchBtn = document.getElementById('ymm-search-btn');
    if (!yearSel || !makeSel || !modelSel || !engineSel) return;

    function enable(sel) { sel.removeAttribute('disabled'); sel.style.opacity = '1'; }
    function populate(sel, items, placeholder) {
      sel.innerHTML = '<option value="">' + placeholder + '</option>';
      items.forEach(function(item) {
        var opt = document.createElement('option');
        opt.value = item;
        opt.textContent = item;
        sel.appendChild(opt);
      });
      enable(sel);
    }

    yearSel.value = clean(vehicle.year);
    populate(makeSel, window.YMMData && window.YMMData.getMakes ? window.YMMData.getMakes() : ['Chevrolet','Dodge','Ford','GMC','RAM','Jeep'], 'Select Make');
    makeSel.value = clean(vehicle.make);

    if (window.YMMData) {
      var models = window.YMMData.getModels(clean(vehicle.make));
      if (models.length) {
        populate(modelSel, models, 'Select Model');
        modelSel.value = clean(vehicle.model);
      }
      var engines = window.YMMData.getEngines(clean(vehicle.make), clean(vehicle.model), clean(vehicle.year));
      if (engines.length) {
        populate(engineSel, engines, 'Select Engine');
        engineSel.value = clean(vehicle.engine);
      } else {
        engineSel.innerHTML = '<option value="">No engine data</option>';
        engineSel.setAttribute('disabled', '');
        engineSel.style.opacity = '0.5';
      }
    }

    if (searchBtn) {
      var engineRequired = !engineSel.disabled && engineSel.options.length > 1;
      var ok = yearSel.value && makeSel.value && modelSel.value && (!engineRequired || engineSel.value);
      searchBtn.disabled = !ok;
      searchBtn.style.opacity = ok ? '1' : '0.4';
    }
  }

  function syncVehicleToPage(vehicle, opts) {
    opts = opts || {};
    if (!vehicle) return;
    try { sessionStorage.setItem('lk_vehicle', JSON.stringify(vehicle)); } catch(e) {}
    syncActiveLabels(vehicle);

    if (opts.navigate && !isCollectionPage()) {
      window.location.href = targetUrlForVehicle(vehicle);
      return;
    }

    if (isCollectionPage() && opts.navigate && !collectionMatchesVehicle(vehicle)) {
      window.location.href = targetUrlForVehicle(vehicle);
      return;
    }

    if (isCollectionPage()) {
      syncVehicleToUrl(vehicle);
      syncVehicleToCollectionControls(vehicle);
      if (typeof window.runFitmentFilter === 'function') {
        window.runFitmentFilter(vehicle.year, vehicle.make, vehicle.model, vehicle.engine || '');
      }
      if (typeof window.LKApplyStrictVehicleFilter === 'function') {
        setTimeout(window.LKApplyStrictVehicleFilter, 80);
      }
      if (typeof window.LKRenderCollectionPage === 'function') {
        setTimeout(function() { window.LKRenderCollectionPage(1); }, 120);
      }
    }
  }

  function setActive(id, opts) {
    try { localStorage.setItem(ACTIVE_KEY, id); } catch(e) {}
    var v = load().filter(function(x){ return x.id === id; })[0];
    if (v) {
      try { sessionStorage.setItem('lk_vehicle', JSON.stringify(v)); } catch(e) {}
    } else {
      try { sessionStorage.removeItem('lk_vehicle'); } catch(e) {}
      syncActiveLabels(null);
    }
    if (v && opts && opts.broadcast) broadcastGarageChanged(v);
    if (v && opts && opts.sync) syncVehicleToPage(v, opts);
    return v || null;
  }
  function addVehicle(year, make, model, engine, opts) {
    opts = opts || {};
    year = clean(year);
    make = clean(make);
    model = clean(model);
    engine = clean(engine);
    if (!year || !make || !model) return null;

    var garage = load();
    var id = year + '-' + make.toLowerCase() + '-' + model.toLowerCase().replace(/\s+/g,'-') + '-' + (engine ? engine.toLowerCase().replace(/\s+/g,'-') + '-' : '') + Date.now();
    var dup = garage.filter(function(v){
      return norm(v.year) === norm(year)
        && norm(v.make) === norm(make)
        && norm(v.model) === norm(model)
        && norm(v.engine) === norm(engine);
    })[0];
    if (!dup && engine) {
      dup = garage.filter(function(v) {
        return norm(v.year) === norm(year)
          && norm(v.make) === norm(make)
          && norm(v.model) === norm(model)
          && !norm(v.engine);
      })[0];
      if (dup) {
        dup.engine = engine;
        save(garage);
      }
    }
    if (dup) {
      setActive(dup.id);
      buildHeaderWidget();
      broadcastGarageChanged(dup);
      syncVehicleToPage(dup, opts);
      return dup;
    }
    var vehicle = { id: id, year: year, make: make, model: model, engine: engine || '', added: Date.now() };
    garage.unshift(vehicle);
    if (garage.length > 5) garage = garage.slice(0, 5); // Max 5 vehicles
    save(garage);
    setActive(id);
    buildHeaderWidget();
    broadcastGarageChanged(vehicle);
    syncVehicleToPage(vehicle, opts);
    return vehicle;
  }

  function selectVehicle(id, opts) {
    var vehicle = setActive(id);
    if (!vehicle) return null;
    buildHeaderWidget();
    broadcastGarageChanged(vehicle);
    syncVehicleToPage(vehicle, opts || { navigate: true });
    applyFitmentBadges();
    return vehicle;
  }

  function clearActiveVehicle(opts) {
    opts = opts || {};
    try { localStorage.setItem(ACTIVE_KEY, NO_ACTIVE); } catch(e) {}
    try { sessionStorage.removeItem('lk_vehicle'); } catch(e) {}
    syncActiveLabels(null);
    applyFitmentBadges();
    buildHeaderWidget();
    broadcastGarageChanged(null);
    emitGarageEvent('lk:garageCleared');
    if (opts.resetCollection) resetCollectionFilter();
    return null;
  }
  function removeVehicle(id) {
    var before = load();
    var previousActiveId = null;
    var previousActive = getActive();
    try { previousActiveId = localStorage.getItem(ACTIVE_KEY); } catch(e) {}

    var garage = before.filter(function(v){ return v.id !== id; });
    save(garage);

    if (garage.length > 0) {
      var next = null;
      if (previousActiveId === NO_ACTIVE) {
        try { localStorage.setItem(ACTIVE_KEY, NO_ACTIVE); } catch(e) {}
        try { sessionStorage.removeItem('lk_vehicle'); } catch(e) {}
        syncActiveLabels(null);
        broadcastGarageChanged(null);
        return;
      }
      if (previousActiveId && previousActiveId !== id) {
        next = garage.filter(function(v){ return v.id === previousActiveId; })[0] || null;
      }
      if (!next && previousActive && previousActive.id !== id) {
        next = garage.filter(function(v){ return v.id === previousActive.id; })[0] || null;
      }
      if (!next) next = garage[0];
      setActive(next.id);
      broadcastGarageChanged(next);
    } else {
      // Garage is empty — clear everything
      try { sessionStorage.removeItem('lk_vehicle'); } catch(e) {}
      try { localStorage.removeItem(ACTIVE_KEY); } catch(e) {}
      // Fire event so collection page resets filter
      emitGarageEvent('lk:garageCleared');
      // Reset the collection YMM filter if on a collection page
      resetCollectionFilter();
    }
  }

  function resetCollectionFilter() {
    // Clear URL params without reloading
    try {
      var url = new URL(window.location.href);
      var hadParams = url.searchParams.has('year') || url.searchParams.has('make');
      url.searchParams.delete('year');
      url.searchParams.delete('make');
      url.searchParams.delete('model');
      url.searchParams.delete('engine');
      if (hadParams) {
        window.history.replaceState({}, '', url.toString());
      }
    } catch(e) {}

    // Reset the YMM dropdowns if they exist on this page
    var yearSel   = document.getElementById('filter-year') || document.getElementById('ymm-year');
    var makeSel   = document.getElementById('filter-make') || document.getElementById('ymm-make');
    var modelSel  = document.getElementById('filter-model') || document.getElementById('ymm-model');
    var engineSel = document.getElementById('filter-engine') || document.getElementById('ymm-engine');
    if (yearSel)   { yearSel.value = ''; }
    if (makeSel)   { makeSel.innerHTML = '<option value="">Make</option>'; makeSel.disabled = true; makeSel.style.opacity = '0.5'; }
    if (modelSel)  { modelSel.innerHTML = '<option value="">Model</option>'; modelSel.disabled = true; modelSel.style.opacity = '0.5'; }
    if (engineSel) { engineSel.innerHTML = '<option value="">Select Engine</option>'; engineSel.disabled = true; engineSel.style.opacity = '0.5'; }

    // Clear the active vehicle badge count
    var countEl = document.querySelector('.lk-garage-count');
    if (countEl) countEl.remove();

    // Trigger filter clear — show all products
    if (typeof window.clearFitmentFilter === 'function') {
      window.clearFitmentFilter();
    }

    // Re-show all hidden fitment-wrap cards
    document.querySelectorAll('.fitment-wrap').forEach(function(w) {
      w.style.display = '';
      w.removeAttribute('data-fitment-hidden');
      w.removeAttribute('data-filtered-out');
      w.removeAttribute('data-lk-paged-hidden');
      w.classList.remove('lk-force-hidden');
      w.classList.remove('lk-page-hidden');
    });

    // Clear the YMM active badge if shown
    var badge = document.getElementById('ymm-active-badge');
    if (badge) badge.remove();

    // Clear the cross-platform notice if shown
    var notice = document.getElementById('cross-platform-notice');
    if (notice) notice.remove();

    syncActiveLabels(null);
    if (typeof window.LKRenderCollectionPage === 'function') window.LKRenderCollectionPage(1);
  }

  // ── GARAGE HEADER WIDGET ───────────────────────────────────
  function openGarage(opts) {
    opts = opts || {};
    var panel = document.getElementById('lk-garage-panel');
    if (!panel) {
      buildHeaderWidget();
      panel = document.getElementById('lk-garage-panel');
    }
    if (!panel) return;
    panel.classList.add('open');
    panel.setAttribute('aria-hidden', 'false');
    if (opts.add) {
      var openAdd = panel.querySelector('#lk-open-add-form');
      var addForm = panel.querySelector('#lk-add-form');
      if (openAdd && addForm && addForm.style.display === 'none') {
        openAdd.click();
      }
    }
  }

  function buildHeaderWidget() {
    var active = getActive();
    var garage = load();

    // Inject button into header actions (before cart)
    var actions = document.querySelector('.site-header__actions');
    if (!actions) return;

    // Remove existing
    var old = document.getElementById('lk-garage-btn');
    if (old) old.parentNode.removeChild(old);
    var oldPanel = document.getElementById('lk-garage-panel');
    if (oldPanel) oldPanel.parentNode.removeChild(oldPanel);

    // Garage button
    var btn = document.createElement('button');
    btn.id = 'lk-garage-btn';
    btn.className = 'header-icon lk-garage-trigger';
    btn.setAttribute('aria-label', 'My Garage');
    btn.setAttribute('title', 'My Garage');
    btn.innerHTML = garageIcon(garage.length) + (active ? '<span class="lk-garage-vehicle-label">' + active.year + ' ' + active.make + '</span>' : '<span class="lk-garage-vehicle-label">My Garage</span>');
    actions.insertBefore(btn, actions.firstChild);

    // Panel
    var panel = document.createElement('div');
    panel.id = 'lk-garage-panel';
    panel.className = 'lk-garage-panel';
    panel.setAttribute('aria-hidden', 'true');
    panel.innerHTML = buildPanelHTML(garage, active);
    document.body.appendChild(panel);

    // Toggle
    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      var open = panel.classList.toggle('open');
      panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    });
    document.addEventListener('click', function(e) {
      if (e.target.closest('[data-open-garage-add], [data-open-garage]')) return;
      if (!panel.contains(e.target) && e.target !== btn) {
        panel.classList.remove('open');
        panel.setAttribute('aria-hidden', 'true');
      }
    });

    // Wire up panel events
    wirePanel(panel);
  }

  function garageIcon(count) {
    return '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" style="flex-shrink:0">'
      + '<path d="M3 13L5 7H19L21 13M3 13H21M3 13V17M21 13V17M6 17V19M18 17V19" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>'
      + '</svg>'
      + (count > 0 ? '<span class="lk-garage-count">' + count + '</span>' : '');
  }

  function buildPanelHTML(garage, active) {
    var html = '<div class="lk-garage-panel__header"><span>My Garage</span><button class="lk-garage-panel__close" aria-label="Close">✕</button></div>';

    if (garage.length === 0) {
      html += '<div class="lk-garage-empty">'
        + '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" style="color:var(--color-gray);margin-bottom:12px"><path d="M3 13L5 7H19L21 13M3 13H21M3 13V17M21 13V17M6 17V19M18 17V19" stroke="currentColor" stroke-width="1.5"/></svg>'
        + '<p>No vehicles saved yet.</p>'
        + '<p style="font-size:0.82rem;color:var(--color-gray);">Add a vehicle to filter parts instantly on every page.</p>'
        + '</div>';
    } else {
      html += '<div class="lk-garage-vehicles">';
      garage.forEach(function(v) {
        var isActive = active && active.id === v.id;
        html += '<div class="lk-garage-vehicle' + (isActive ? ' active' : '') + '" data-vid="' + v.id + '">'
          + '<div class="lk-garage-vehicle__info" data-select="' + v.id + '">'
          + '<div class="lk-garage-vehicle__name">' + v.year + ' ' + v.make + ' ' + v.model + '</div>'
          + (v.engine ? '<div class="lk-garage-vehicle__engine">' + v.engine + '</div>' : '')
          + (isActive ? '<div class="lk-garage-vehicle__active-badge">● Active</div>' : '')
          + '</div>'
          + '<button type="button" class="lk-garage-vehicle__remove" data-remove="' + v.id + '" aria-label="Remove vehicle">✕</button>'
          + '</div>';
      });
      html += '</div>';
    }

    html += '<div class="lk-garage-add">'
      + '<button class="btn btn--primary btn--small lk-garage-add-btn" id="lk-open-add-form" style="width:100%;">'
      + '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7 1v12M1 7h12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>'
      + ' Add a Vehicle'
      + '</button>'
      + '</div>';

    // Inline add form (hidden initially)
    html += '<div class="lk-garage-add-form" id="lk-add-form" style="display:none;">'
      + '<select id="lgf-year"><option value="">Year</option></select>'
      + '<select id="lgf-make" disabled><option value="">Make</option></select>'
      + '<select id="lgf-model" disabled><option value="">Model</option></select>'
      + '<select id="lgf-engine" disabled><option value="">Select Engine</option></select>'
      + '<button class="btn btn--primary btn--small" id="lgf-save" disabled style="width:100%;margin-top:6px;">Save to Garage</button>'
      + '<button class="btn btn--secondary btn--small" id="lgf-cancel" style="width:100%;margin-top:6px;">Cancel</button>'
      + '</div>';

    if (active) {
      html += '<div class="lk-garage-shop-btn">'
        + '<a href="' + targetUrlForVehicle(active) + '" class="btn btn--secondary btn--small" style="width:100%;">'
        + 'Shop Parts for My ' + active.year + ' ' + active.make
        + '</a></div>';
    }

    return html;
  }

  function wirePanel(panel) {
    // Close button
    var closeBtn = panel.querySelector('.lk-garage-panel__close');
    if (closeBtn) closeBtn.addEventListener('click', function() {
      panel.classList.remove('open');
    });

    // Select or remove a saved vehicle. Remove is handled first so the click
    // cannot accidentally select the vehicle underneath the remove button.
    panel.addEventListener('click', function(e) {
      var rem = e.target.closest('[data-remove]');
      if (rem) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
        rem.disabled = true;
        removeVehicle(rem.getAttribute('data-remove'));
        buildHeaderWidget();
        openGarage();
        applyFitmentBadges();
        return;
      }

      var sel = e.target.closest('[data-select]');
      if (sel) {
        e.preventDefault();
        selectVehicle(sel.getAttribute('data-select'), { navigate: true });
      }
    });

    // Open add form
    var openAdd = panel.querySelector('#lk-open-add-form');
    var addForm = panel.querySelector('#lk-add-form');
    if (openAdd && addForm) {
      openAdd.addEventListener('click', function() {
        openAdd.style.display = 'none';
        addForm.style.display = 'block';
        initAddForm(panel);
      });
    }

    var cancelBtn = panel.querySelector('#lgf-cancel');
    if (cancelBtn) cancelBtn.addEventListener('click', function() {
      if (addForm) addForm.style.display = 'none';
      if (openAdd) openAdd.style.display = '';
    });
  }

  function initAddForm(panel) {
    if (!window.YMMData) return;
    var form = panel.querySelector('#lk-add-form');
    if (form && form.getAttribute('data-initialized') === 'true') return;
    if (form) form.setAttribute('data-initialized', 'true');
    var D = window.YMMData;
    var yearSel   = panel.querySelector('#lgf-year');
    var makeSel   = panel.querySelector('#lgf-make');
    var modelSel  = panel.querySelector('#lgf-model');
    var engineSel = panel.querySelector('#lgf-engine');
    var saveBtn   = panel.querySelector('#lgf-save');

    // Populate years
    var curYear = new Date().getFullYear();
    for (var y = curYear; y >= 1984; y--) {
      var o = document.createElement('option'); o.value = y; o.textContent = y;
      yearSel.appendChild(o);
    }

    var engineRequired = false;

    function enable(sel)  { sel.disabled = false; sel.style.opacity = '1'; }
    function disable(sel, ph) {
      sel.disabled = true;
      sel.style.opacity = '0.5';
      sel.innerHTML = '<option value="">' + ph + '</option>';
    }
    function populate(sel, items, ph) {
      sel.innerHTML = '<option value="">' + ph + '</option>';
      items.forEach(function(v) { var o = document.createElement('option'); o.value = v; o.textContent = v; sel.appendChild(o); });
      enable(sel);
    }
    function updateSave() {
      var ok = yearSel.value && makeSel.value && modelSel.value && (!engineRequired || engineSel.value);
      saveBtn.disabled = !ok;
      saveBtn.style.opacity = saveBtn.disabled ? '0.4' : '1';
    }

    // Pre-populate makes
    populate(makeSel, window.YMMData && window.YMMData.getMakes ? window.YMMData.getMakes() : ['Chevrolet','Dodge','Ford','GMC','RAM','Jeep'], 'Select Make');

    yearSel.addEventListener('change', function() {
      disable(modelSel, 'Model');
      disable(engineSel, 'Select Engine');
      engineRequired = false;
      updateSave();
    });
    makeSel.addEventListener('change', function() {
      if (makeSel.value) populate(modelSel, D.getModels(makeSel.value), 'Select Model');
      else disable(modelSel, 'Model');
      disable(engineSel, 'Select Engine');
      engineRequired = false;
      updateSave();
    });
    modelSel.addEventListener('change', function() {
      engineRequired = false;
      if (yearSel.value && makeSel.value && modelSel.value) {
        var engines = D.getEngines(makeSel.value, modelSel.value, yearSel.value);
        if (engines.length) {
          populate(engineSel, engines, 'Select Engine');
          engineRequired = true;
          maybeAutoSelectDieselEngine(engineSel, engines);
        } else {
          disable(engineSel, 'No engine data');
        }
      }
      updateSave();
    });
    engineSel.addEventListener('change', updateSave);

    saveBtn.addEventListener('click', function() {
      if (saveBtn.disabled) return;
      addVehicle(yearSel.value, makeSel.value, modelSel.value, engineSel.value, { navigate: true });
      applyFitmentBadges();
      // Close panel after save
      setTimeout(function() {
        var p = document.getElementById('lk-garage-panel');
        if (p) p.classList.remove('open');
      }, 400);
    });
  }

  // ── FITMENT BADGES ON PRODUCT CARDS ───────────────────────
  function applyFitmentBadges() {
    if (!window.LKFilter) return;
    if (document.getElementById('lk-shop-status')) return;
    var active = getActive();

    // Remove all existing badges first
    document.querySelectorAll('.lk-fits-badge').forEach(function(b){ b.parentNode.removeChild(b); });
    document.querySelectorAll('.fitment-wrap.lk-suggested-fit').forEach(function(w){ w.classList.remove('lk-suggested-fit'); });

    if (!active) return;
    if (!(active.year && active.make && active.model && active.engine)) return;

    if (document.getElementById('product-grid') && typeof window.LKApplyStrictVehicleFilter === 'function') {
      syncVehicleToUrl(active);
      window.LKApplyStrictVehicleFilter();
      return;
    }

    // Target .fitment-wrap divs in the collection grid (they hold data-title and data-tags)
    var wraps = document.querySelectorAll('.fitment-wrap');
    wraps.forEach(function(wrap) {
      var title = (wrap.getAttribute('data-title') || '').toLowerCase();
      var tags  = (wrap.getAttribute('data-tags') || '').split(',').filter(Boolean);
      var type  = wrap.getAttribute('data-type') || '';
      var vendor = wrap.getAttribute('data-vendor') || '';
      var status = window.LKFilter.productFitmentBadge
        ? window.LKFilter.productFitmentBadge(title, tags, active.year, active.make, active.model, active.engine, type, vendor)
        : null;
      var fits  = status ? status.matches : window.LKFilter.productMatchesVehicle(title, tags, active.year, active.make, active.model, active.engine, type, vendor);
      if (fits) {
        wrap.classList.add('lk-suggested-fit');
        // Inject into the image-wrap inside the product card for correct positioning
        var imgWrap = wrap.querySelector('.product-card__image-wrap');
        if (imgWrap) {
          var badge = document.createElement('div');
          badge.className = 'lk-fits-badge';
          badge.innerHTML = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2 6l3 3 5-5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg> Suggested Fit — Verify';
          badge.setAttribute('title', 'Matched to the selected year, platform, and engine from product title, tags, type, and vendor. Verify before ordering.');
          status = status || {
            confidence: 'suggested',
            label: 'Suggested Fit - Verify',
            title: 'Matched to the selected vehicle. Verify before ordering.'
          };
          badge.className = 'lk-fits-badge lk-fitment-badge--' + (status.confidence || 'suggested');
          badge.innerHTML = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2 6l3 3 5-5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg> ' + (status.label || 'Suggested Fit - Verify');
          badge.setAttribute('title', status.title || 'Matched to the selected vehicle. Verify before ordering.');
          badge.setAttribute('aria-label', status.ariaLabel || status.label || 'Suggested fit for selected vehicle. Verify before ordering.');
          imgWrap.appendChild(badge);
        }
      }
    });
  }

  // ── PRODUCT PAGE: "FITS MY TRUCK" CHECK ───────────────────
  function checkProductFitment() {
    var productTitle = document.querySelector('.product-info__title');
    if (!productTitle) return;

    var active = getActive();
    var title = productTitle.textContent.toLowerCase();
    var tagMeta = document.querySelector('meta[name="product-tags"]');
    var tags = tagMeta ? tagMeta.getAttribute('content').split(',') : [];

    var zone = document.querySelector('.product-info__stock');
    if (!zone) return;

    // Remove existing
    var old = document.getElementById('lk-product-fitment-check');
    if (old) old.parentNode.removeChild(old);

    var div = document.createElement('div');
    div.id = 'lk-product-fitment-check';
    div.style.cssText = 'margin-bottom:var(--space-md);padding:10px 14px;border-radius:6px;font-family:var(--font-condensed);font-size:0.85rem;font-weight:700;letter-spacing:0.05em;display:flex;align-items:center;gap:8px;';

    if (!active) {
      div.style.background = 'rgba(255,255,255,0.04)';
      div.style.border = '1px solid var(--color-border)';
      div.style.color = 'var(--color-gray)';
      div.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M3 13L5 7H19L21 13M3 13H21M3 13V17M21 13V17M6 17V19M18 17V19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>'
        + '<span>Save your vehicle to check fitment</span>'
        + '<button id="lk-check-add-vehicle" style="margin-left:auto;background:none;border:1px solid var(--color-accent);color:var(--color-accent);padding:3px 10px;border-radius:4px;font-size:0.8rem;cursor:pointer;font-family:var(--font-condensed);font-weight:700;">Add Vehicle</button>';
      zone.parentNode.insertBefore(div, zone.nextSibling);
      var addBtn = document.getElementById('lk-check-add-vehicle');
      if (addBtn) addBtn.addEventListener('click', function() {
        var garageBtn = document.getElementById('lk-garage-btn');
        if (garageBtn) garageBtn.click();
      });
      return;
    }

    var status = window.LKFilter.productFitmentBadge
      ? window.LKFilter.productFitmentBadge(title, tags, active.year, active.make, active.model, active.engine)
      : null;
    var fits = status ? status.matches : window.LKFilter.productMatchesVehicle(title, tags, active.year, active.make, active.model, active.engine);
    var label = active.year + ' ' + active.make + ' ' + active.model;

    if (fits) {
      div.style.background = 'rgba(26,138,58,0.12)';
      div.style.border = '1px solid rgba(26,138,58,0.35)';
      div.style.color = '#1a8a3a';
      var fitLabel = status && status.confidence === 'verified' ? 'Verified fit for your ' : 'Suggested fit for your ';
      div.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7l4 4 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        + fitLabel + label + ' - verify VIN-specific options before ordering';
    } else {
      div.style.background = 'rgba(196,134,13,0.1)';
      div.style.border = '1px solid rgba(196,134,13,0.3)';
      div.style.color = '#c4860d';
      div.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7 2v6M7 11v1" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>'
        + 'May not fit your ' + label + ' — verify before ordering';
    }

    zone.parentNode.insertBefore(div, zone.nextSibling);
  }

  // ── RECENTLY VIEWED ────────────────────────────────────────
  var RV_KEY = 'lk_recent_v1';
  function trackRecentlyViewed() {
    var handle = window.location.pathname.match(/\/products\/([^/?]+)/);
    if (!handle) return;
    try {
      var recent = JSON.parse(localStorage.getItem(RV_KEY) || '[]');
      var title  = document.querySelector('.product-info__title')?.textContent?.trim() || '';
      var price  = document.querySelector('.price-main')?.textContent?.trim() || '';
      var img    = document.querySelector('#main-product-img')?.getAttribute('src') || '';
      var url    = window.location.pathname;
      recent = recent.filter(function(r){ return r.handle !== handle[1]; });
      recent.unshift({ handle: handle[1], title: title, price: price, img: img, url: url, ts: Date.now() });
      if (recent.length > 8) recent = recent.slice(0, 8);
      localStorage.setItem(RV_KEY, JSON.stringify(recent));
    } catch(e) {}
  }

  function renderRecentlyViewed() {
    var container = document.getElementById('lk-recently-viewed');
    var section   = document.getElementById('lk-rv-section');
    if (!container) return;
    try {
      var recent = JSON.parse(localStorage.getItem(RV_KEY) || '[]');
      var handle = window.location.pathname.match(/\/products\/([^/?]+)/);
      if (handle) recent = recent.filter(function(r){ return r.handle !== handle[1]; });
      if (recent.length === 0) {
        if (section) section.style.display = 'none';
        return;
      }
      var html = recent.slice(0, 4).map(function(r) {
        return '<a href="' + r.url + '" class="rv-card">'
          + (r.img ? '<img src="' + r.img + '" alt="' + r.title + '" loading="lazy">' : '')
          + '<div class="rv-card__title">' + r.title + '</div>'
          + '<div class="rv-card__price">' + r.price + '</div>'
          + '</a>';
      }).join('');
      container.innerHTML = html;
    } catch(e) {
      if (section) section.style.display = 'none';
    }
  }

  // ── INIT ───────────────────────────────────────────────────
  function init() {
    // Sync active vehicle to sessionStorage on every page
    // If garage is empty, make sure sessionStorage is also cleared
    var active = getActive();
    if (active) {
      try { sessionStorage.setItem('lk_vehicle', JSON.stringify(active)); } catch(e) {}
      syncActiveLabels(active);
    } else {
      // No vehicle in garage — clear any stale sessionStorage
      try { sessionStorage.removeItem('lk_vehicle'); } catch(e) {}
    }

    if (!active) syncActiveLabels(null);

    // Capture vehicle add from collection YMM widget or homepage selector
    document.addEventListener('lk:vehicleAdded', function(e) {
      if (e.detail) addVehicle(e.detail.year, e.detail.make, e.detail.model, e.detail.engine);
    });

    document.addEventListener('click', function(e) {
      var trigger = e.target.closest('[data-open-garage-add], [data-open-garage]');
      if (!trigger) return;
      e.preventDefault();
      openGarage({ add: trigger.hasAttribute('data-open-garage-add') });
    });

    buildHeaderWidget();
    setTimeout(applyFitmentBadges, 300);
    setTimeout(checkProductFitment, 100);
    trackRecentlyViewed();
    renderRecentlyViewed();
  }

  return {
    init: init,
    addVehicle: addVehicle,
    selectVehicle: selectVehicle,
    clearActiveVehicle: clearActiveVehicle,
    getActive: getActive,
    load: load,
    targetCollectionForVehicle: targetCollectionForVehicle,
    isGasVehicle: isGasVehicle,
    targetUrlForVehicle: targetUrlForVehicle,
    openGarage: openGarage,
    syncVehicleToPage: syncVehicleToPage,
    syncActiveToPage: function(opts) { return syncVehicleToPage(getActive(), opts || {}); },
    applyFitmentBadges: applyFitmentBadges,
    checkProductFitment: checkProductFitment,
  };

})();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    window.LKGarage.init();
  });
} else {
  window.LKGarage.init();
}

